import React, { useState } from "react";
import {
    Container,
    Card,
    CardContent,
    Grid,
    Typography,
    Chip,
    Box,
    makeStyles,
    Paper,
} from "@material-ui/core";
import { EdgeFileUploadStage } from "./EdgePinch/EdgeFileUploadstage";
import { EdgePreviewAndEditStage } from "./EdgePinch/EdgePreviewAndEdit";
import { EdgeFinalSubmitStage } from "./EdgePinch/EdgeFinalSubmit";



const useStyles = makeStyles((theme) => ({
    root: {
        marginTop: theme.spacing(4),
    },

    pageTitle: {
        fontSize: 40,
        fontWeight: 500,
        marginBottom: theme.spacing(1),
        color: "#111827",
    },

    subTitle: {
        fontSize: 18,
        color: "#4B5563",
        marginBottom: theme.spacing(5),
        maxWidth: 900,
        lineHeight: 1.6,
    },

    stepCard: {
        borderRadius: 24,
        padding: theme.spacing(4),
        minHeight: 180,
        border: "1px solid #E5E7EB",
        position: "relative",
        transition: "all 0.2s ease",
        background: "#fff",
    },

    activeStep: {
        border: "2px solid #0F5C66",
        boxShadow: "0 4px 18px rgba(0,0,0,0.06)",
    },

    stepNumber: {
        fontSize: 30,
        color: "#8B93A7",
        fontWeight: 300,
        marginBottom: theme.spacing(2),
    },

    stepLabel: {
        fontSize: 12,
        letterSpacing: 2,
        textTransform: "uppercase",
        color: "#8B93A7",
        marginBottom: theme.spacing(1),
    },

    stepTitle: {
        fontSize: 18,
        fontWeight: 600,
        marginBottom: theme.spacing(2),
        color: "#111827",
    },

    stepDesc: {
        fontSize: 14,
        color: "#4B5563",
    },

    chip: {
        position: "absolute",
        top: 24,
        right: 24,
        borderRadius: 30,
        fontWeight: 600,
        letterSpacing: 1,
    },

    contentWrapper: {
        marginTop: theme.spacing(5),
    },
}));

export const EdgeUploadComponent = ({ asset, onSuccess, }: any) => {
    const classes = useStyles();

    const [step, setStep] = useState(1);

    const [tableData, setTableData] = useState<any>({});
    const [tableDatashow, setTableDatashow] = useState<any>({});
    const [selectedFile, setSelectedFile] = useState<File | null>(null);

    const getStatus = (cardStep: number) => {
        if (step > cardStep) {
            return {
                label: "DONE",
                color: "#0F5C66",
                bg: "#D7F0EE",
            };
        }

        if (step === cardStep) {
            return {
                label: "REVIEWING",
                color: "#6B7280",
                bg: "#F3F4F6",
            };
        }

        return {
            label: "PENDING",
            color: "#9CA3AF",
            bg: "#F3F4F6",
        };
    };

    const steps = [
        {
            number: "01",
            label: "STEP 1",
            title: "Upload Edge Pinch File",
            desc: selectedFile
                ? `${selectedFile.name}`
                : "Upload Kiwa / PVEL template",
        },
        {
            number: "02",
            label: "STEP 2",
            title: "Stage & preview",
            desc: "Review and edit parsed measurements",
        },
        {
            number: "03",
            label: "STEP 3",
            title: "Submit to record",
            desc: "Lock revision & notify lead",
        },
    ];

    return (
        <Container maxWidth="xl" className={classes.root}>
            {/* HEADER */}
            <Box mb={6}>
                <Typography className={classes.pageTitle}>
                    Edge Pinch Test
                </Typography>
            </Box>

            <Paper elevation={4} style={{ padding: 10 }}>
                <Grid container spacing={3}>

                    {steps.map((item, index) => {
                        const status = getStatus(index + 1);

                        return (
                            <Grid item xs={12} md={4} key={item.number}>
                                <Card
                                    className={`${classes.stepCard} ${step === index + 1 ? classes.activeStep : ""
                                        }`}
                                    elevation={0}
                                >
                                    <Chip
                                        label={status.label}
                                        className={classes.chip}
                                        style={{
                                            background: status.bg,
                                            color: status.color,
                                        }}
                                    />

                                    <Typography className={classes.stepNumber}>
                                        {item.number}
                                    </Typography>

                                    <Typography className={classes.stepLabel}>
                                        {item.label}
                                    </Typography>

                                    <Typography className={classes.stepTitle}>
                                        {item.title}
                                    </Typography>

                                    <Typography className={classes.stepDesc}>
                                        {item.desc}
                                    </Typography>
                                </Card>
                            </Grid>
                        );
                    })}
                </Grid>

                {/* STEP CONTENT */}
                <Box className={classes.contentWrapper}>
                    <Card>
                        <CardContent>
                            {step === 1 && (
                                <EdgeFileUploadStage
                                    asset={asset}
                                    selectedFile={selectedFile}
                                    setTableDatashow={setTableDatashow}
                                    setSelectedFile={setSelectedFile}
                                    setTableData={setTableData}
                                    onContinue={() => setStep(2)}
                                />
                            )}

                            {step === 2 && (
                                <EdgePreviewAndEditStage
                                    tableData={tableData}
                                    setTableData={setTableData}
                                    onBack={() => setStep(1)}
                                    onContinue={() => setStep(3)}
                                />
                            )}

                            {step === 3 && (
                                <EdgeFinalSubmitStage
                                    asset={asset}
                                    showdata={tableDatashow}
                                    tableData={tableData}
                                    onBack={() => setStep(2)}
                                    onSuccess={() => {
                                        setStep(1);
                                        setTableData({});
                                        setTableDatashow({});
                                        setSelectedFile(null);

                                        onSuccess?.();
                                    }}
                                />
                            )}
                        </CardContent>
                    </Card>
                </Box>
            </Paper>


        </Container>
    );
};